export enum PAGES {
	HOME = 'agent-manager',
	LIST = 'agent-manager.list',
	CREATE = 'agent-manager.create',
	DETAILS = 'agent-manager.details',
}
